import { render, staticRenderFns } from "./DashboardTabLineage.vue?vue&type=template&id=38f23e85&scoped=true&lang=pug"
import script from "./DashboardTabLineage.vue?vue&type=script&lang=js"
export * from "./DashboardTabLineage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f23e85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f23e85')) {
      api.createRecord('38f23e85', component.options)
    } else {
      api.reload('38f23e85', component.options)
    }
    module.hot.accept("./DashboardTabLineage.vue?vue&type=template&id=38f23e85&scoped=true&lang=pug", function () {
      api.rerender('38f23e85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/tableau/components/dashboard/DashboardTabLineage.vue"
export default component.exports